<template>
  <div>
    <VDialog v-model="dialog" max-width="450">
      <VCard style="overflow: auto">
        <VBtn absolute style="right: 0" class="mt-1" icon @click="close">
          <VIcon>mdi-close</VIcon>
        </VBtn>
        <VCardTitle>{{ $t("confirmWithEimzo") }}</VCardTitle>

        <VCardText v-if="listItems.length">
          <VCol
            v-for="(item, i) in listItems"
            :key="i"
            cols="12"
            class="pr-0 pl-0"
          >
            <VCard :color="item.color">
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <VCardTitle class="text-h6" v-if="item.contractId"
                    >{{ $t("contractNumber") }} :
                    {{ item.contractCode }}</VCardTitle
                  >
                  <VCardTitle class="text-h6" v-else
                    >{{ $t("requestNumber") }} :
                    {{ item.orderNumber }}</VCardTitle
                  >

                  <VCardSubtitle
                    ><span class="font-weight-bold"
                      >{{ $t("productName") }}:</span
                    >
                    {{ item.productName }}</VCardSubtitle
                  >

                  <VCardText style="color: #36c281" v-if="item.contractId">{{
                    $t(`contractStatus.${item.signedEntity}`)
                  }}</VCardText>
                  <VCardText style="color: #36c281" v-else>{{
                    $t(`agreementStatus.${item.signedEntity}`)
                  }}</VCardText>
                </div>
              </div>
            </VCard>
          </VCol>
          <VBtn
            color="primary"
            width="100%"
            v-if="listItems.length"
            @click="openEImzoDialog"
            >{{ $t("approve") }}</VBtn
          >
        </VCardText>
        <VCardText v-else>
          {{ $t("noApprovedContracts") }}
        </VCardText>
      </VCard>
      <EImzoDialog ref="eimzoDialogRef" @getToken="setHashESign"></EImzoDialog>
    </VDialog>
    <VBtn :loading="loading" color="primary" @click="open"
      >{{ $t("confirmWithKey") }}
      <v-avatar size="22" width="20" left class="indigo lighten-5 ml-2">
        <span class="black--text">{{ listItems.length }}</span>
      </v-avatar></VBtn
    >
  </div>
</template>

<script>
import EImzoDialog from "@/components/omtk/E-imzoDialog.vue";
export default {
  name: "ConfirmKeyDialog",
  components: {
    EImzoDialog,
  },
  data() {
    return {
      dialog: false,
      listItems: [],
      loading: false,
    };
  },
  created() {
    this.refreshList();
  },
  methods: {
    refreshList() {
      this.getListItemsWithKey();
    },
    openEImzoDialog() {
      const { eimzoDialogRef } = this.$refs;
      if (eimzoDialogRef) {
        let contractIds = this.listItems.map((item) => {
          return item.unSignedId;
        });
        eimzoDialogRef.open(contractIds);
      }
    },
    async setHashESign(hashESign) {
      this.showLoading();
      try {
        await this.$http.post("unsigned/set-hash-e-sign", `"${hashESign}"`, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        this.close();
        await this.getListItemsWithKey();
        this.$emit("eimzo-signed");
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async getListItemsWithKey() {
      this.loading = true;
      try {
        const {
          data: { data },
        } = await this.$http.get("unsigned/list-item");
        this.listItems = [...data];
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
